export default __webpack_public_path__ + "static/media/warning--stop-ahead--g3.f1875ba8.png";